import Meta from 'src/components/meta/Meta';

const RentToBuyHomeMeta = () => <Meta
  title="Smart Renter | BrickX"
  description="Smart Renter by BrickX gives you the opportunity to purchase your first home with just a 5-10% deposit! Get your foot on the property ladder and buy your first home sooner with BrickX."
  keywords="rent to buy, first home buyer, low deposit"
/>;

export default RentToBuyHomeMeta;
